import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for PWR5J3 (樣品交運單核准沖銷)
// ============================================================

export interface ReverseCandidate {
  fj130_01: string; // 交運單號
  fj130_11: string; // 交運日期
  fj130_12: string; // 客戶代碼/名稱
  fj130_21: string; // 業務員代碼/姓名
  fj130_22: string; // 部門代碼/名稱
  fj130_80: string; // 狀態碼
}

export interface QueryResponse {
  items: ReverseCandidate[];
  total: number;
}

export interface ReverseResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const pwr5j3Api = {
  /** Query sample delivery order candidates eligible for reversal */
  async queryCandidates(startNo: string, endNo: string): Promise<QueryResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start'] = startNo.trim();
    if (endNo.trim()) params['end'] = endNo.trim();
    const res = await apiClient.get('/api/pwr5j3/candidates', { params });
    return res.data;
  },

  /** Execute batch reversal for selected sample delivery orders */
  async reverse(items: string[]): Promise<ReverseResponse> {
    const res = await apiClient.post('/api/pwr5j3/reverse', { items });
    return res.data;
  },
};
